<template>
  <footer class="vl-footer">
    <div class="logo">
      <img src="../assets/img/logo_footer.png" alt="" />
    </div>
    <div class="vl-ft-content">
      <div class="ft-item active" @click="toHelp">帮助中心</div>
      <div class="fm-line"></div>
      <div class="ft-item active" @click="toPortal">门户管理</div>
      <div class="fm-line"></div>
      <div class="ft-item">版权所有：宁夏回族自治区教育厅</div>
      <div class="fm-line"></div>
      <div class="ft-item">技术支持：宁夏教育信息化管理中心</div>
      <div class="fm-line"></div>
      <div class="ft-item">服务热线：0951-5559291 5559148</div>
      <div class="fm-line"></div>
      <div class="ft-item active" @click="toBei">宁ICP备16000125号</div>
      <div class="fm-line"></div>
      <div class="ft-item active" @click="toRecord">
        宁公网安备 64010602000493号
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    methods: {
      toHelp() {
        let url = window.ENV_API.OUTSIDE_PORTAL_URL + "/czsc.jhtml";
        window.open(url);
      },
      toPortal() {
        let url = window.ENV_API.OUTSIDE_PORTAL_URL + "/jeecms/index.html";
        window.open(url);
      },
      toOpen() {
        let url = window.ENV_API.DOP_URL + "/developer/#/home";
        window.open(url);
      },
      toRecord() {
        let url =
          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=64010602000493";
        window.open(url);
      },
      toBei() {
        window.open('https://beian.miit.gov.cn/')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .vl-footer {
    width: 100%;
    height: 200px;
    padding-top: 50px;
    background: #1e2730;
    .logo {
      width: 401px;
      height: 58px;
      margin: auto;
      img {
        //width: 401px;
        height: 58px;
      }
    }
    .vl-ft-content {
      width: 1300px;
      margin: 0 auto;
      margin-top: 27px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      .ft-item {
        color: #ffffff;
        opacity: 0.5;
      }
      .active {
        cursor: pointer;
        &:hover {
          color: #4286f5;
          opacity: 1;
        }
      }
      .fm-line {
        width: 1px;
        height: 17px;
        opacity: 0.15;
        background: #ffffff;
      }
    }
  }

</style>
